import { createWithI18n } from '@post-office/message-maker-browser/i18n';

import { messagesLoader as postOfficeTeam } from '@post-office/team-package--i18n--post-office-team';
import { messagesLoader as growth } from '@post-office/team-package--i18n--growth';
import { messagesLoader as jiraPulsar } from '@post-office/team-package--i18n--jira-pulsar';
import { messagesLoader as rovoChat } from '@post-office/team-package--i18n--rovo-chat';
import { type AnyProps } from '@post-office/message-maker-browser/types';
import { type ComponentType } from 'react';

export const withI18n: <T extends AnyProps>(component: ComponentType<T>) => ComponentType<T> =
	createWithI18n(postOfficeTeam, growth, jiraPulsar, rovoChat);
